import post, { API } from '../../net/http';
import moment from 'moment';
const format = 'MM/DD/YY';

export default {
  namespaced: true,
  state: {
    warehouse: [],
    calculate: null,
  },
  actions: {
    search(content, body) {
      return post(API.estimate, {
        backPostcode: body.rzipcode,
        sendPostcode: body.zipcode,
        weightLb: body.weight,
        count: body.count ? body.count : 1,
        pickup: body.pickup,
      });
    },
    getWareHouse({ state }) {
      state.warehouse = [];
      return post(API.warehouse).then(res => {
        if (res.success) {
          state.warehouse = res.data
            .filter(item => item.coordinate)
            .map(item => {
              let coordinate = item.coordinate.split(',');
              return { ...item, lat: coordinate[0], lng: coordinate[1] };
            });
        }
        return res;
      });
    },
  },
  mutations: {},
};
